<template>
  <div class="thanks" :style="`text-align: left; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
    <el-row style="margin-top: 30px;" >
      <el-col :xl="{span: 14, offset: 5}" :lg="{span: 15, offset: 5}" :md="{span: 18, offset: 3}"
        :sm="{span: 20, offset: 2}" :xs="{span: 22, offset: 1}">
        This website relies on open data sharing by various institutes across the country. The labs that directly contributed to generation and dissemination of SARS-CoV-2 genomic resources are as follows*
        <ul>
          <li v-for="lab in store.datasets.labs" :key="lab">
            {{ lab }}
          </li>
        </ul>
        <div>* Note, this list is manually curated from the GISAID metadata table. Please contact <a href="mailto:tej@ccmb.res.in"  class="click-link">tej@ccmb.res.in</a> if there are errors/corrections.</div>
      </el-col>
      
    </el-row>
  </div>
</template>

<script>
import {store} from '@/scripts/store'

export default {
  data () {
    return {
      store
    }
  }
}
</script>

<style>
.click-link {
  text-decoration: none;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: rgba(150, 155, 155, 0.6);
  font-size: 0.8em; 
  font-weight: bold;
}
</style>